import React, { Component } from 'react';
import './CompanyInfoPopup.css';
import PopupTitleBar from './PopupTitleBar';
import ScoreBox from '../ScoreBox';
import Config from '../../Configs/criteria.json';

export default class CompanyInfoPopup extends Component {
    constructor(props) {
        super(props);
        // this.closePopupHandler = this.closePopupHandler.bind(this);
        // this.handleScoreBoxChange = this.handleScoreBoxChange.bind(this);
        // this.handleConfirm = this.handleConfirm.bind(this);

        let score = [];
        if (props.score) {
            score = [...props.score];
        } else {
            for (let i = 0; i < Config.criteria.score.length; i++) {
                score.push({ disabled: true, value: [0, 10] });
            }
        }

        this.state = {
            score,
            marginTop: "300px"
        }

        

        }
        closePopupHandler = () => {
            this.props.closePopup();
        }
        handleScoreBoxChange = (index, disabled, value) => {
            this.score = this.state.score;
            this.score[index] = { disabled, value };
            this.setState({ score: this.score });
        }
        handleConfirm = () => {
            this.props.submit(this.state.score);
            this.closePopupHandler();
        }
        componentDidMount(){
            if (this.props.compInfo[2] &&this.props.appId!=="Hyper") {
                if (this.props.compInfo[2] < 2) {
                    this.setState({ marginTop: "300px" })
                } else if (this.props.compInfo[2] < 4) {
                    this.setState({ marginTop: "450px" })
                } else if (this.props.compInfo[2] < 6) {
                    this.setState({ marginTop: "600px" })
                } else if (this.props.compInfo[2] < 8) {
                    this.setState({ marginTop: "900px" })
                } else if (this.props.compInfo[2] < 10) {
                    this.setState({ marginTop: "1000px" })
                }else{
                    this.setState({ marginTop: "300px" })
                }
            }
        }
        render() {
            return (
                <div className={this.props.appId==="Hyper"?"CompanyInfoPopup Hyper":"CompanyInfoPopup"} style={{marginTop:this.props.appId==="Hyper"?"auto":this.state.marginTop}}>
                    <PopupTitleBar title="企業概況" closePopup={this.closePopupHandler} />
                    <div className="container">
                        <div className="compHeader">
                            {this.props.compInfo[0]}
                        </div>
                        <br></br>
                        <div className="compInfo">
                            {this.props.compInfo[1]}
                        </div>



                    </div>
                    {/* <div className="confirmbtn" onClick={this.handleConfirm}>適用</div> */}
                </div>
            )
        }
    }